<template>
  <login-form @loginSuccess="loginSuccess"></login-form>
</template>

<script>
  import LoginForm from './../login/LoginForm.vue'
  import { api } from "../../config";
  import {mapActions} from "vuex";

  export default {
    components: {
      'login-form': LoginForm
    },
    created() {
      this.$store.dispatch('selectLanguage', 'en')
    },
    methods: {
      ...mapActions([
        'setAuthUser'
      ]),
      loginSuccess(data) {;
        this.setAuthUser(data.user);
        // Set user's Language
        let self = this;
        self.$store.dispatch('selectLanguage', data.user.language)
        if(!data.user.email_verified_at) {
          window.location.href = '/signup/verify';
          
        } else if(data.user.active_at) {
          if(data.user.subscribed && data.user.subscription.trial
            && data.user.subscription.trial_ends_at) {
            
            self.$router.push({name: 'apps.trial'});
          } else {
            self.$router.push({ name: 'top' });
          }
        } else  {
          if(data.user.expired_at) {
            let nowDate = new Date();
            let expredAt = new Date(data.user.expired_at);
            if(nowDate.getTime() > expredAt.getTime()) {
              return self.$router.push({name: 'apps.expired'});
            }
          } else {
            if(data.user.subscribed) {
              if(!data.user.subscription.gracePeriod && data.user.subscription.cancelled && data.user.subscription.ended) {
                return self.$router.push({name: 'apps.purchase'});
              }
            }
          }
          self.$router.push({name: 'apps.trial'});
        }
      }
    }
  }
</script>
